module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/congratulations/Wedding_Pop-1829b3cdf8d521efc191c9f14f4d4bf7.jpg";